import React from 'react'
import PropTypes from 'prop-types'
import { ContainerBox } from './Container.styles'

function Container({ children, style }) {
  return (
    <ContainerBox style={style}>
      <main>
        {children}
      </main>
    </ContainerBox>
  )
}

Container.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
}

export default Container
